var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wbs-page-title",class:_vm.classe},[_c('h4',[_vm._v(_vm._s(_vm.titulo))]),_c('p',{staticClass:"text-muted mb-2"},[_vm._v(_vm._s(_vm.descricao))])])}
var staticRenderFns = []

export { render, staticRenderFns }